import React from 'react';
import { StepProps } from '../MultiStepModal';

const JOB_TYPES = [
  { value: 'EMERGENCY', label: 'Emergency callout', icon: '🚨', sla: '2–4 hrs', priority: 'URGENT', cert: 'Safety report' },
  { value: 'MAINTENANCE', label: 'Maintenance visit', icon: '🔧', sla: '3–5 days', priority: 'MEDIUM', cert: 'Service record' },
  { value: 'INSTALLATION', label: 'Installation', icon: '🏗️', sla: '1 week', priority: 'MEDIUM', cert: 'Commissioning cert' },
  { value: 'INSPECTION', label: 'Inspection / compliance', icon: '📋', sla: '2 weeks', priority: 'HIGH', cert: 'Gas Safety / CP12' },
  { value: 'REPAIR', label: 'Repair', icon: '🔩', sla: '24–48 hrs', priority: 'HIGH', cert: 'Job sheet' },
  { value: 'OTHER', label: 'Other', icon: '📁', sla: 'Flexible', priority: 'LOW', cert: 'None' },
];

export default function JobTypeStep({ data, onDataChange }: StepProps) {
  return (
    <div className="step-form">
      <div className="step-header">
        <h3 className="step-form-title">What type of job is this?</h3>
        <p className="step-form-subtitle">This sets the SLA, priority, and required certificate type automatically.</p>
      </div>
      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
        {JOB_TYPES.map((t) => {
          const selected = data.jobType === t.value;
          return (
            <button
              key={t.value}
              type="button"
              onClick={() => onDataChange({ jobType: t.value, priority: t.priority })}
              className={`flex items-start gap-3 rounded-xl border px-4 py-3.5 text-left transition-all ${
                selected
                  ? 'border-[#1B1B1B] bg-[#F8F8F8] ring-1 ring-[#1B1B1B]'
                  : 'border-[#E6E6E4] bg-white hover:border-[#CDCDCD] hover:bg-[#FAFAFA]'
              }`}
            >
              <span className="text-2xl leading-none mt-0.5">{t.icon}</span>
              <div className="min-w-0">
                <p className="text-[13px] font-semibold text-[#191919]">{t.label}</p>
                <p className="text-[11px] text-[#6B7280] mt-0.5">SLA: {t.sla}</p>
                <p className="text-[11px] text-[#6B7280]">Cert: {t.cert}</p>
              </div>
              {selected && (
                <span className="ml-auto flex-shrink-0 mt-0.5 h-4 w-4 rounded-full bg-[#1B1B1B] flex items-center justify-center">
                  <svg className="h-2.5 w-2.5 text-white" fill="currentColor" viewBox="0 0 12 12">
                    <path d="M10 3L5 8.5 2 5.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
                  </svg>
                </span>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
}
